export default __webpack_public_path__ + "static/media/expert-home.a0a6c26f.svg";